import React, { FC } from 'react'
import { type GameWithoutLivestream } from '../../types'
import { AboutStream } from '../AboutStream/AboutStream'

type StreamPageTabContentProps = {
  mediaObject: GameWithoutLivestream
}

export const StreamPageTabContent: FC<StreamPageTabContentProps> = ({
  mediaObject
}) => {
  return <AboutStream mediaObject={mediaObject} />
}
